import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

let sceneEnter: any = null,
    sceneLeave: any = null;
export default function A() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('smart_home_panel_2.launch.detail');
    const [visible, setVisible] = useState(false);
    const [enter, setEnter] = useState(false);

    const handlePlay = () => {
        setVisible(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            video_name: t('secA_title'),
            position: 'Product Launch_1',
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneEnter) {
                    AniContainer.removeScene(sceneEnter);
                    sceneEnter = null;
                }
                if (sceneLeave) {
                    AniContainer.removeScene(sceneLeave);
                    sceneLeave = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneEnter = AniContainer.create({
                    triggerElement: '.shp2-detail-A',
                    triggerHook: 1,
                    offset: startH,
                    duration: 200,
                    onEnter: () => setEnter(true),
                });
            };
            resizeAni();
            // window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneEnter) {
                    AniContainer.removeScene(sceneEnter);
                    sceneEnter = null;
                }
                if (sceneLeave) {
                    AniContainer.removeScene(sceneLeave);
                    sceneLeave = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`shp2-detail-A shp2-detail-section ${css['shp2-detail-A']}`}>
            <div className={`img-box ${enter ? 'enter' : ''}`}>
                <EFPicture
                    src={'/responsive/picture/smart-home-panel-2/launch/1.jpg'}
                    srcPad={'/responsive/picture/smart-home-panel-2/launch/1_768.jpg'}
                    srcMobile={'/responsive/picture/smart-home-panel-2/launch/1_768.jpg'}
                    alt={t('secA_title')}
                />
            </div>
            <div className={`info-box ${enter ? 'enter' : ''}`}>
                <h3 className="subtitle">{t('secA_subtitle')}</h3>
                <h1 className="title">{t('secA_title')}</h1>
                <button className="video" onClick={handlePlay}>
                    <span className="video-text">{t('secA_watch')}</span>
                    <svg className="video-icon" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.5 0.5C4.08172 0.5 0.5 4.08172 0.5 8.5C0.5 12.9183 4.08172 16.5 8.5 16.5C12.9183 16.5 16.5 12.9183 16.5 8.5C16.5 4.08172 12.9183 0.5 8.5 0.5ZM7.53418 11.5065L11.2507 8.82435C11.4719 8.6647 11.4719 8.3353 11.2507 8.17565L7.53418 5.49351C7.26963 5.30259 6.9001 5.49162 6.9001 5.81786L6.9001 11.1821C6.9001 11.5084 7.26963 11.6974 7.53418 11.5065Z"
                            fill="white"
                        />
                    </svg>
                </button>
            </div>
            <EFVideoModal
                visible={visible}
                source={'https://www.youtube.com/embed/zsonj2HPQdM?si=2GSK67QBoFc7Azgk'}
                onClose={() => setVisible(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </section>
    );
}
